//
// Module for Rollovers edit view
//
rs.module("participant/benefit/rollovers/edit",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, ajaxUrls, benefitPaid, isCreate) {
            var rolloverForm = $.js(jsSelectors.rolloverForm);

            var existingAgencySelection = rolloverForm.js(jsSelectors.existingAgencySelect);
            var existingAgencyMailToField = rolloverForm.js(jsSelectors.existingAgencyMailTo);

            var existingAgencyAddressText = rolloverForm.js(jsSelectors.existingAgencyAddress);

            var addAgencyCheckBox = rolloverForm.js(jsSelectors.addAgency, { required: false });

            var newAgencyGrouping = rolloverForm.js(jsSelectors.newAgencySection, { required: false });
            var enterManually = $.js(jsSelectors.enterManually, { required: false });
            var avasOverride = $.js(jsSelectors.avasOverride, { required: false });
            var avasOverrideHidden = $.js(jsSelectors.avasOverrideHidden, { required: false });
            var countryHiddenInput = $.js(jsSelectors.countryHiddenInput, { required: false });
            var newAgencyAddressCountry = $.js(jsSelectors.newAgencyAddressCountry, { required: false });

            if (!benefitPaid) {
                existingAgencySelection.change(function () {

                    $.get(ajaxUrls.populateExistingAgencyAddressUrl, { rolloverAgencyKey: this.value }).done(function (result) {
                        existingAgencyAddressText.html(result);
                    });

                    if (this.value) {
                        $.getJSON(ajaxUrls.populateExistingAgencyMailToUrl, { rolloverAgencyKey: this.value }).done(function (result) {
                            existingAgencyMailToField.find(':input').val(result.mailTo).clearErrors();
                        });
                    }
                    else {
                        existingAgencyMailToField.find(':input').val('').clearErrors();
                    }
                });

                if (isCreate) {
                    addAgencyChanged();

                    addAgencyCheckBox.change(addAgencyChanged);
                }
            }

            //clear and default fields based on addAgencyCheckBox
            function addAgencyChanged() {
                var addRolloverAgency = addAgencyCheckBox[0].checked;
                var existingAgencySelectorHelper = selectHelper.getHelper(existingAgencySelection);

                if (addRolloverAgency) {
                    existingAgencySelectorHelper.setValue('');

                    existingAgencyAddressText.html('');

                    visibility.hide(existingAgencyMailToField);
                    visibility.show(newAgencyGrouping);

                    countryHiddenInput.val(newAgencyAddressCountry.val());
                } else {
                    clearGroup(newAgencyGrouping);

                    //Default Check Address Type to Main
                    selectHelper.getHelper(newAgencyGrouping.js(jsSelectors.newAgencyAddressTypeSelect)).setValue(codeValues.mainCodeValue.toString());

                    //Default Country to USA
                    selectHelper.getHelper(newAgencyGrouping.js(jsSelectors.newAgencyAddressCountry)).setValue(codeValues.usaCodeValue.toString());

                    visibility.show(existingAgencyMailToField);
                    visibility.hide(newAgencyGrouping);
                }

                existingAgencySelectorHelper.setDisabled(addRolloverAgency);
            }

            //clear all inputs and selects of a given group
            //with selects using selectHelper to properly set the value
            function clearGroup(grouping) {
                grouping.find(":input").not(avasOverride).not(avasOverrideHidden).not(enterManually).val('');
                grouping.find("select").each(function () { selectHelper.getHelper($(this)).setValue(''); });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);